// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".FakeAutocompleteField_input__2BA7e {\n  display: none; }\n\n.FakeAutocompleteField_fakeInput__Qd13u {\n  position: fixed;\n  top: -100px;\n  left: -100px;\n  width: 5px; }\n", ""]);
// Exports
exports.locals = {
	"input": "FakeAutocompleteField_input__2BA7e",
	"fakeInput": "FakeAutocompleteField_fakeInput__Qd13u"
};
module.exports = exports;
